
define('app/board/views/playerRanksView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'app/board/collections/pickSummaryCollection',
	'app/board/collections/queueCollection',
	'known/models/leagueInstanceModel',
	'app/board/models/draftStatusModel',
	'app/board/models/positionColorsModel',
	'app/board/views/playerRankingView',
	'app/board/util/playerList',
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		PickSummaryCollection, 
		QueueCollection,
		LeagueInstanceModel, 
		DraftStatusModel, 
		PositionColorsModel,
		PlayerRankingView, 
		PlayerList){
	var PlayerRanksView = Backbone.View.extend({
		el: $("#playerRankView"),
		
		initialize: function(options) {
			this.user = options.userModel;
			this.pickSummaryCollection = options.pickSummaryCollection;
			this.playerList = options.playerList;
			this.leagueInstance = options.leagueInstance;
			this.draftStatus = options.draftStatus;
			this.posColors = options.posColors;
			this.prodConfig = options.prodConfig;
			this.queueCollection = options.queueCollection;
			this.sportsTeams = options.sportsTeams;
			
			this.showDraftedPlayers = true;
			this.rankAttr = 'OVRRANK';
			this.teamFilter = 'ALL';
			this.sortCategory = 'OVRRANK';
			this.stats = new Array();
			this.ranksEnabled = this.leagueInstance.get('ranksEnabled');
			this.projsEnabled = this.leagueInstance.get('statsEnabled');
			this.rankPos = null;
			this.clickableHeaderList = {};
			this.isSortDirectionAsc = true;
			
			this.timer = 0;
			
			this.playerRankingViews = [];
			
			this.playerContainer = $(this.el).find('#playerRankingsContainer');
			this.rankTypeSelect = $(this.el).find('#rankTypeSelect');
			this.teamFilterSelect = $(this.el).find('#rankTeamFilterSelect');
			this.showDraftedCheckbox = $(this.el).find('#rankShowDrafted');
			this.rankSearchInput = $(this.el).find('#rankSearchInput');
			this.numResultsSelect = $(this.el).find('#numResultsSelect');
			
			this.createInputs();
			
			_.bindAll(this, 'renderPlayerRanks');
			_.bindAll(this, 'playerPicked');
			_.bindAll(this, 'playerUnpicked');
			_.bindAll(this, 'keyUp');
			_.bindAll(this, 'flipSortCategoryHeaders');			
			
			this.user.bind("change", this.pickOwnerRender, this);
			this.draftStatus.bind("change", this.pickOwnerRender, this);
			
			this.rankTypeSelect.on('change', this.renderPlayerRanks);
			this.numResultsSelect.on('change', this.renderPlayerRanks);
			this.teamFilterSelect.on('change', this.renderPlayerRanks);
			this.showDraftedCheckbox.on('click', this.renderPlayerRanks);
			this.rankSearchInput.on("keyup", this.keyUp);
			
			$(document).on('draftApp:playerPicked', this.playerPicked);
			$(document).on('draftApp:playerUnpicked', this.playerUnpicked);
		},
		
		render: function () {
			this.pickOwnerRender();
			this.createInputs();
			this.renderPlayerRanks();
			
			if(this.leagueInstance.get('id') == 70119){
				$(this.el).find('#playerRankingQueueWidget').hide();
				$(this.el).find('.lastRankingWidget').hide();
				$(this.el).find('#playerRankingsStatusContainer').css("height", "100%" );
			}
			
			return this;
		},
		
		keyUp: function(e) {
			this.delay(this.renderPlayerRanks, 200 );			
		},
		
		delay: function(callback, ms) {
			clearTimeout(this.timer);
			this.timer = setTimeout(callback, ms);
		},
		
		createInputs: function() {
			this.rankTypeSelect.empty();
			
			var optionStart = "<option value=\"";
			var optionMiddle = "\" >";
			var optionEnd = "</option>";
			
			this.rankTypeSelect.append(optionStart 
					+ 'ALL'
					+ "\" selected=\"true"
					+ optionMiddle
					+ 'All Positions'						
					+ optionEnd);
			if(this.leagueInstance.get('prodLeagueName') == 'MLB') {
				this.rankTypeSelect.append(optionStart 
						+ 'HITRANK'
						+ optionMiddle
						+ 'Hitters'						
						+ optionEnd);
				this.rankTypeSelect.append(optionStart 
						+ 'PITCHRANK'
						+ optionMiddle
						+ 'Pitchers'						
						+ optionEnd);
			}
			
			if(this.leagueInstance.get('prodLeagueName') == 'NFL') {
				this.rankTypeSelect.append(optionStart 
						+ 'RKRANK'
						+ optionMiddle
						+ 'Rookies'						
						+ optionEnd);
			}
			
			this.leagueInstance.get('leaguePositions').each(function(lgPos) {
				//Lets skip putting in OL here
				//if(lgPos.get('name') != 'OL'){
					this.rankTypeSelect.append(optionStart 
							+ lgPos.get('id').replace(',','.')
							+ optionMiddle
							+ lgPos.get('name')						
							+ optionEnd);
				//}				
			}, this);
			
			this.teamFilterSelect.empty();
			this.teamFilterSelect.append(optionStart 
					+ 'ALL'
					+ "\" selected=\"true"
					+ optionMiddle
					+ 'All Teams'						
					+ optionEnd);
			
			var curSportsTeams = this.sportsTeams;
			var sportTeamKeys = _.keys(curSportsTeams);
			var sortedSportTeamKeys = _.sortBy(sportTeamKeys, function(key){ return key; }); 
				
			_.each(sortedSportTeamKeys, 
				function(key){
					var optionElHtml = '<option value="' + key + '">' + curSportsTeams[key] + '</option>';
					var optionEl = $(optionElHtml);
					this.teamFilterSelect.append(optionEl);
				}
			, this);
		},
		
		pickOwnerRender: function () {
			var pickSum = this.pickSummaryCollection.get(this.pickSummaryCollection.getPosRoundId(this.draftStatus.get('round'), this.draftStatus.get('posInRound')));
			var isAuctionBidding = false;
			if(this.leagueInstance.get('draftStatus') == 'STARTED' && this.leagueInstance.get('draftType') == 'AUCTION' && this.draftStatus.get('auctionBidding')){
				isAuctionBidding = true;
			}
			
			//Make sure the pick sum is found and that this isn't past the trial range			
			if(!isAuctionBidding && pickSum && (this.prodConfig.TRIAL == 'false' || this.draftStatus.get('round') <= parseInt(this.prodConfig.TRIALRDS))){
				var teamOwner = this.leagueInstance.getTeamOwner(pickSum.get('fantasyTeamId'));
				var userName = this.user.get('userName');
				var isAssistant = this.leagueInstance.isAssistant(userName);
				var isDraftStarted = this.leagueInstance.get('draftStatus') == 'STARTED';
				
				//Change color of button for commish
				if(isAssistant && userName.toUpperCase() != teamOwner.toUpperCase()){
					this.$el.find('.draftRankedPlayerBtn').removeClass('btn-success');
					this.$el.find('.draftRankedPlayerBtn').addClass('btn-info');
				} else {
					this.$el.find('.draftRankedPlayerBtn').removeClass('btn-info');
					this.$el.find('.draftRankedPlayerBtn').addClass('btn-success');
				}
				
				if(isDraftStarted && (isAssistant || userName.toUpperCase() == teamOwner.toUpperCase())){
					this.$el.addClass('pickPlayerAllowed');
				} else {
					this.$el.removeClass('pickPlayerAllowed');
				}
			} else {
				this.$el.removeClass('pickPlayerAllowed');
			}
		},
		
		renderPlayerRanks: function() {
			this.configRanks();
			this.removeAllPlayerRanks();
			this.renderHeader();
			this.configSortCategory();
			this.renderSortCategoryHeaders();
			this.playerContainer.find('tbody').empty();
			this.addAllPlayerRanks();
		},
		
		configRanks: function() {
			var type = this.rankTypeSelect.val();			
			this.showDraftedPlayers = this.showDraftedCheckbox.prop("checked");
			var team = this.teamFilterSelect.val();
			
			var lgPos = null;
			
			//Force a couple changes if they are searching
			if(this.rankSearchInput.val() && this.rankSearchInput.val() != ''){
				type = "ALL";
				team = "ALL";
				this.showDraftedPlayers = true;
			}
			
			if(type != "ALL" && type != "HITRANK" && type != "PITCHRANK" && type != "RKRANK") {
				lgPos = this.leagueInstance.get('leaguePositions').get(type.replace('.',','));
			}
			
			var rankAttr = null;
			var stats = new Array();
			
			if(lgPos) {
				rankAttr = lgPos.getRankingType();
				stats = lgPos.getProjectionCategories();
			} 
			
			if(rankAttr == null) {
				//This should just be all positions
				switch (type) {
				case "ALL":
					rankAttr = 'OVRRANK';
					break;
				case "HITRANK":
					rankAttr = 'HITRANK';
					break;
				case "PITCHRANK":
					rankAttr = 'PITCHRANK';
					break;
				case "RKRANK":
					//rankAttr = 'RKRANK';
					rankAttr = 'OVRRANK';
					break;
				default:
					rankAttr = 'OVRRANK';
					break;
				}				
			}
			
			if(stats == null || stats.length == 0){
				if(this.leagueInstance.get('prodLeagueName') == 'NFL'){
					stats = [
			                  'RUSH_ATT',
			                  'RUSH_YDS',
			                  'RUSH_TDS',
			                  'REC',
			                  'REC_YDS',
			                  'REC_TDS',
			                  'PASS_ATT',
			                  'PASS_COMP',
			                  'PASS_YDS',
			                  'PASS_TDS',
			                  'PASS_INTS',
			                  'FUMBLE'];
				} else {
					stats = [];
				}
			}
			
			//Position changed, so change the sort category to the default
			if(lgPos != this.rankPos){
				this.sortCategory = rankAttr == 'OVRRANK' ? 'OVRRANK' : 'POSRANK';
				this.isSortDirectionAsc = true;
			}
			
			this.rankAttr = rankAttr;
			this.rankPos = lgPos;
			this.stats = stats;
			this.teamFilter = team;
		},
		
		renderHeader: function() {
			var ranksEnabled = this.ranksEnabled;
			var projsEnabled = this.projsEnabled;
			
			var isUserSearching = (this.rankSearchInput.val() && this.rankSearchInput.val() != '');
			
			var rankAttr = this.rankAttr;
			var stats = this.stats;
			
			this.playerContainer.find('thead').empty();
			this.clickableHeaderList = {};
			
			var playerNameHeader = $('<th class="playerRanksPlayerHdr">Player <i class="icon-caret-down statSortAsc"></i><i class="icon-caret-up statSortDesc"></i></th>');			
			if(!isUserSearching){
				playerNameHeader.addClass('defaultSortAsc');
				playerNameHeader.on('click', {type: 'ALPHA'}, this.flipSortCategoryHeaders);
			}
			
			this.clickableHeaderList['ALPHA'] = playerNameHeader;
			
			var row = $('<tr></tr>');
			row.append($('<th colspan="2">Actions</th>'));
			row.append(playerNameHeader);			
			row.append($('<th class="playerRanksPosHdr">Pos</th>'));
			row.append($('<th class="playerRanksTeamHdr">Team</th>'));
			
			if(ranksEnabled) {
				var ovrRankHeader = null;
				if(rankAttr != 'OVRRANK'){
					var posRankHeader = $('<th>Pos Rank <i class="icon-caret-down statSortAsc"></i><i class="icon-caret-down statSortDesc"></i></th>');
					ovrRankHeader = $('<th>Ovr Rank <i class="icon-caret-down statSortAsc"></i><i class="icon-caret-down statSortDesc"></i></th>');					
					
					row.append(posRankHeader);					
					
					if(!isUserSearching){
						posRankHeader.addClass('defaultSortAsc');
						posRankHeader.on('click', {type: 'POSRANK'}, this.flipSortCategoryHeaders);
					}					
					
					this.clickableHeaderList['POSRANK'] = posRankHeader;					
				} else {
					ovrRankHeader = $('<th>Rank <i class="icon-caret-down statSortAsc"></i><i class="icon-caret-up statSortDesc"></i></th>');
				}
				
				row.append(ovrRankHeader);
				
				if(!isUserSearching){
					ovrRankHeader.addClass('defaultSortAsc');
					ovrRankHeader.on('click', {type: 'OVRRANK'}, this.flipSortCategoryHeaders);
				}
				
				this.clickableHeaderList['OVRRANK'] = ovrRankHeader;
			}
			
			if(projsEnabled) {
				for(var i=0; i<stats.length; i++){
					var cat = stats[i];
					
					switch (cat) {
					case "PASS_ATT": cat = "Pa Atts";	break; 			
					case "PASS_COMP": cat = "Pa Comps";	break;
					case "PASS_YDS": cat = "Pa Yds";	break;
					case "PASS_TDS": cat = "Pa TDs";	break;
					case "PASS_INTS": cat = "Pa Ints";	break;
					case "RUSH_ATT": cat = "Ru Atts";	break;
					case "RUSH_YDS": cat = "Ru Yds";	break;
					case "RUSH_TDS": cat = "Ru TDs";	break;
					case "REC": cat = "Recs";	break;
					case "REC_YDS": cat = "Rec Yds";	break;
					case "REC_TDS": cat = "Rec TDs";	break;
					case "FUMBLE": cat = "Fumbles";	break;
					case "K_FGM": cat = "FG Made";	break;
					case "K_FGA": cat = "FG Att";	break;
					case "K_XP": cat = "FG XP";	break;
					case "K_MISS": cat = "FG Miss";	break;
					case "DEF_SACK": cat = "Sack";	break;
					case "DEF_FR": cat = "FR";	break;
					case "DEF_INT": cat = "Int";	break;
					case "DEF_TD": cat = "TD";	break;
					case "DEF_SFTY": cat = "Sfty";	break;
					case "DEF_PA": cat = "PA";	break;
					case "DEF_YA": cat = "YA";	break;
					case "IDP_TK": cat = "TKs";	break;
					case "IDP_ASSIST": cat = "Assists";	break;
					case "IDP_SACK": cat = "Sacks";	break;
					case "IDP_PADEF": cat = "Pa Def";	break;
					case "IDP_INT": cat = "Ints";	break;
					case "IDP_FF": cat = "FFs";	break;
					case "IDP_FR": cat = "FRs";	break;
					case "TM_WINS": cat = "Wins";	break;
					case "TM_LOSSES": cat = "Losses";	break;
					case "PUNTS": cat = "Punts";	break;
					case "PUNT_YDS": cat = "P Yds";	break;
					case "PUNT_RETYD": cat = "P Ret Yds";	break;
					case "PUNT_INS20": cat = "P Ins 20";	break;
					default: break;
					}
					
					var catHeader = $('<th>' + cat + ' <i class="icon-caret-down statSortAsc"></i><i class="icon-caret-up statSortDesc statSortDefault"></i></th>'); 
					row.append(catHeader);
					
					if(!isUserSearching){
						catHeader.addClass('defaultSortDesc');
						catHeader.on('click', {type: stats[i]}, this.flipSortCategoryHeaders);
					}					
					
					this.clickableHeaderList[stats[i]] = catHeader;
				}
			}
			
			if(!ranksEnabled && !projsEnabled){
				row.append($('<th>&nbsp;</th>'));
			}
			
			this.playerContainer.find('thead').append(row);
		},
		
		configSortCategory: function(catType, flip){
			if (typeof(catType)==='undefined') catType = this.sortCategory;
			if (typeof(flip)==='undefined') flip = false;
			
			var isSortDirectionAsc = true;
			
			//Just double check to make sure ranks aren't used when specifically disabled
			if(!this.ranksEnabled && (catType == 'OVRRANK' || catType == 'POSRANK')) {
				catType = 'ALPHA';
			}
			
			if(catType == this.sortCategory){
				//This is already the current sorting category, so check the current direction
				isSortDirectionAsc = flip ? !this.isSortDirectionAsc : this.isSortDirectionAsc;
			} else {
				//Not currently the active sorting category, so make it active depending on the default sort type
				isSortDirectionAsc = this.clickableHeaderList[catType].hasClass('defaultSortDesc') ? false : true;
			}
			
			this.isSortDirectionAsc = isSortDirectionAsc;
			this.sortCategory = catType;
		},
		
		flipSortCategoryHeaders: function(event){
			if(!this.rankSearchInput.val() || this.rankSearchInput.val() == ''){
				//Don't change anything on player searches
				if(event && event.data && event.data.type){
					this.configSortCategory(event.data.type, true);
				}
				
				this.renderPlayerRanks();
			}
		},
		
		renderSortCategoryHeaders: function() {
			var catType = this.sortCategory;
			var isUserSearching = (this.rankSearchInput.val() && this.rankSearchInput.val() != '');
			
			for(var key in this.clickableHeaderList) {
				if(key == catType && !isUserSearching){
					this.clickableHeaderList[key].addClass('activeSortCat')
					if(this.isSortDirectionAsc){
						this.clickableHeaderList[key].removeClass('activeSortCatDesc');
						this.clickableHeaderList[key].addClass('activeSortCatAsc');
					} else {
						this.clickableHeaderList[key].addClass('activeSortCatDesc');
						this.clickableHeaderList[key].removeClass('activeSortCatAsc');
					}
				} else {
					this.clickableHeaderList[key].removeClass('activeSortCat');
					this.clickableHeaderList[key].removeClass('activeSortCatDesc');
					this.clickableHeaderList[key].removeClass('activeSortCatAsc');
				}
			}
		},
		
		addPlayerRank: function(player) {
			var view = new PlayerRankingView({
				player: player, 
				rankAttr: this.rankAttr,
				projCatArr: this.stats,
				draftStatus: this.draftStatus,
				leagueInstance: this.leagueInstance,
				pickSummaryCollection: this.pickSummaryCollection,
				posColors: this.posColors,
				user : this.user,
				queueCollection: this.queueCollection});
			//this.listenTo(team, 'change:draftPosition', this.orderChange);
			this.playerContainer.find('tbody').append(view.render().el);
			this.playerRankingViews[player.id] = view;
		},
		
		removePlayerRank: function(player) {
			//this.stopListening(team, 'change:draftPosition', this.orderChange);
			this.playerRankingViews[player.id].destroyView();
			delete this.playerRankingViews[player.id];
		},
		
		addAllPlayerRanks: function() {
			var isSortDirectionAsc = this.isSortDirectionAsc;
			var sortCategory = this.sortCategory;
			var rankAttr = this.rankAttr;
			var sortedPlayers = [];
			var allowedPositions = this.leagueInstance.allowedPositions();
			//var limit = false;  //Don't think I actually need this anymore.  Remove it's usage at some point
			var limit = true;
			var newSearch = true;
			var rookie = false;
			
			if(this.rankSearchInput.val() && this.rankSearchInput.val() != ''){
				sortedPlayers = this.playerList.searchDraftablePlayers(this.rankSearchInput.val(), allowedPositions, true);
				//limit = true;
				newSearch = false;
			} else if(this.ranksEnabled && this.rankPos && (rankAttr != 'OVRRANK' || this.rankPos.get('positions').length > 1)) {
				//Specific position specified and ranking enabled
				allowedPositions = this.rankPos.get('positions');
			} else if(this.rankPos){
				//This is a specific position that doesn't have rankings associated with it, so default to alpha (example: coaches, punters, etc)
				allowedPositions = this.rankPos.get('positions');
				if(sortCategory == 'OVRRANK'){
					sortCategory = 'ALPHA';
					isSortDirectionAsc = true;
				}
			} else if(this.rankTypeSelect.val() == 'RKRANK'){
				//Rookie
				rookie = true;
				//limit = true;
				
				//TODO: Remove this once the NFL draft has occurred
				sortCategory = 'ALPHA';
				isSortDirectionAsc = true;
			} //else {
				//limit = true;
			//} 
			
			if(newSearch){
				var isOnlyRkEnabled = this.leagueInstance.get('rookieEnabled') && !this.leagueInstance.get('vetEnabled');				
				sortedPlayers = this.playerList.sortByCategory(sortCategory, rankAttr, isSortDirectionAsc, this.showDraftedPlayers, allowedPositions, this.teamFilter, rookie, isOnlyRkEnabled);
			}
			
			var numResults = parseInt(this.numResultsSelect.val());
			
			for (var i = 0; i < (limit ? numResults : 999) && i < sortedPlayers.length ; i++) {
				var player = sortedPlayers[i];
				this.addPlayerRank(player);
			}
			
		},
		
		removeAllPlayerRanks: function() {
			_.each(this.playerRankingViews, function(view, key){
				this.playerRankingViews[key].destroyView();
				delete this.playerRankingViews[key];
			}, this);
		},
		
		playerPicked: function(event, playerId) {
			if(this.playerRankingViews[playerId] && this.showDraftedPlayers){
				this.playerRankingViews[playerId].updateDraftStatus();
			} else if(this.playerRankingViews[playerId]){
				this.removePlayerRank(this.playerList.findPlayerByPlayerId(playerId));
			}
		},
		
		playerUnpicked: function(event, playerId) {
			if(this.playerRankingViews[playerId]){
				this.playerRankingViews[playerId].updateDraftStatus();
				return;
			}
			
			var isSortDirectionAsc = this.isSortDirectionAsc;
			var sortCategory = this.sortCategory;			
			var player = this.playerList.findPlayerByPlayerId(playerId);
			var rankAttr = this.rankAttr;
			
			var sortedPlayers = [];
			//var limit = false;  //Don't think I actually need this anymore.  Remove it's usage at some point
			var limit = true;
			var newSearch = false;
			var rookie = false;
			var allowedPositions = this.leagueInstance.allowedPositions();
			if(this.rankSearchInput.val() && this.rankSearchInput.val() != ''){
				//Player would already be found above, so just break out of this function.  No need to perform another search.
				return;
			} else if(this.ranksEnabled && this.rankPos && (rankAttr != 'OVRRANK' || this.rankPos.get('positions').length > 1)) {
				//Specific position specified and ranking enabled
				if(_.intersection(this.rankPos.get('positions'),player.position.split(',')).length > 0){
					allowedPositions = this.rankPos.get('positions');
					newSearch = true;
				}
			} else if(this.rankPos){
				if(_.intersection(this.rankPos.get('positions'),player.position.split(',')).length > 0){
					newSearch = true;
					allowedPositions = this.rankPos.get('positions');
					if(sortCategory == 'OVRRANK'){
						sortCategory = 'ALPHA';
						isSortDirectionAsc = true;
					}
				}
			} else if(this.rankTypeSelect.val() == 'RKRANK'){
				//Rookie
				rookie = true;
				newSearch = true;	
				//limit = true;
				
				//TODO: Remove this once the NFL draft has occurred
				sortCategory = 'ALPHA';
				isSortDirectionAsc = true;
			} else {
				newSearch = true;				
				//limit = true;
			}
				
			if(newSearch) {
				var isOnlyRkEnabled = this.leagueInstance.get('rookieEnabled') && !this.leagueInstance.get('vetEnabled');				
				sortedPlayers = this.playerList.sortByCategory(sortCategory, rankAttr, isSortDirectionAsc, this.showDraftedPlayers, allowedPositions, this.teamFilter, rookie, isOnlyRkEnabled);
			}			
			
			if(sortedPlayers.length > 0) {
				var prevPlayerIdx = null;
				var foundPlayerIdx = -1;
				
				var numResults = parseInt(this.numResultsSelect.val());
								
				for(var i = 0; i < (limit ? numResults : 999) && i < sortedPlayers.length ; i++){
					if(sortedPlayers[i].id != playerId){
						prevPlayerIdx = i;
					} else {
						foundPlayerIdx = i;
						break;
					}
				}
				
				if(prevPlayerIdx && foundPlayerIdx > -1 && sortedPlayers[foundPlayerIdx]){
					//Add the player after the previous ranked player
					var view = new PlayerRankingView({
						player: sortedPlayers[foundPlayerIdx], 
						rankAttr: this.rankAttr,
						projCatArr: this.stats,
						draftStatus: this.draftStatus,
						leagueInstance: this.leagueInstance,
						pickSummaryCollection: this.pickSummaryCollection,
						posColors: this.posColors,
						user : this.user,
						queueCollection: this.queueCollection});					
					$(this.playerRankingViews[sortedPlayers[prevPlayerIdx].id].el).after(view.render().el);
					this.playerRankingViews[sortedPlayers[foundPlayerIdx].id] = view;
				} else if(foundPlayerIdx > -1 && (foundPlayerIdx + 1) < sortedPlayers.length){
					//Add to beginning
					var view = new PlayerRankingView({
						player: sortedPlayers[foundPlayerIdx], 
						rankAttr: this.rankAttr,
						projCatArr: this.stats,
						draftStatus: this.draftStatus,
						leagueInstance: this.leagueInstance,
						pickSummaryCollection: this.pickSummaryCollection,
						posColors: this.posColors,
						user : this.user,
						queueCollection: this.queueCollection});
					$(this.playerRankingViews[sortedPlayers[foundPlayerIdx + 1].id].el).before(view.render().el);
					this.playerRankingViews[sortedPlayers[foundPlayerIdx].id] = view;
				} else if(foundPlayerIdx > -1){
					//Add to end
					var view = new PlayerRankingView({
						player: sortedPlayers[foundPlayerIdx], 
						rankAttr: this.rankAttr,
						projCatArr: this.stats,
						draftStatus: this.draftStatus,
						leagueInstance: this.leagueInstance,
						pickSummaryCollection: this.pickSummaryCollection,
						posColors: this.posColors,
						user : this.user,
						queueCollection: this.queueCollection});
					this.playerContainer.find('tbody').append(view.render().el);
					this.playerRankingViews[sortedPlayers[foundPlayerIdx].id] = view;
				}
			}
		},
		
	});
	
	return PlayerRanksView;  
});